export const PRODUCT_QUERY_PARAM_KEYS = ['product'] as const

export function getProductParamFromSearchParams(searchParams: URLSearchParams): string | null {
  for (const key of PRODUCT_QUERY_PARAM_KEYS) {
    const value = searchParams.get(key)?.trim()
    if (value) {
      return value
    }
  }
  return null
}

export function isBusinessAccountsCatalogParam(searchParams: URLSearchParams): boolean {
  const catalog = searchParams.get('catalog')?.trim().toLowerCase()
  return catalog === 'bao' || catalog === 'business'
}

export function resolveProductId(param: string, availableIds: string[]): string | null {
  const trimmed = param.trim()
  if (!trimmed || availableIds.length === 0) {
    return null
  }

  return availableIds.find((id) => id.toLowerCase() === trimmed.toLowerCase()) ?? null
}

export function matchesProductId(productId: string, param: string, availableIds: string[]): boolean {
  const resolved = resolveProductId(param, availableIds)
  return resolved === productId
}
